/**
 * Utilitário para capturar snapshots do DOM para debug
 */

export interface DOMSnapshot {
  innerHTML: string;
  truncated: boolean;
  length: number;
  timestamp: number;
}

/**
 * Captura snapshot do innerHTML de um elemento
 */
export function snapshotHTML(root: HTMLElement, maxChars: number = 500): DOMSnapshot {
  const innerHTML = root.innerHTML;
  const truncated = innerHTML.length > maxChars;
  
  return {
    innerHTML: truncated ? innerHTML.substring(0, maxChars) + '...' : innerHTML,
    truncated,
    length: innerHTML.length,
    timestamp: Date.now()
  };
}

/**
 * Compara dois snapshots e retorna as diferenças
 */
export function compareSnapshots(before: DOMSnapshot, after: DOMSnapshot): {
  changed: boolean;
  sizeDiff: number;
  beforePreview: string;
  afterPreview: string;
} {
  return {
    changed: before.innerHTML !== after.innerHTML,
    sizeDiff: after.length - before.length,
    beforePreview: before.innerHTML.substring(0, 100) + '...',
    afterPreview: after.innerHTML.substring(0, 100) + '...'
  };
}